<template>
  <router-view v-if="$route.name === 'BookChapter'" :key="$route.fullPath" /> <router-view v-else />
  <!-- <LanguageSwitcher /> -->
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
// import LanguageSwitcher from './components/Languages/LanguageSwitcher.vue';
import { useUserProfileStore } from './stores/platform/accounts/UserProfileStore';

const userStore = useUserProfileStore();

onMounted(() => {
  userStore.HydrateFromLocalStorage();
});
</script>

<style scoped></style>
